<template>
  <section class="underwriting-refer">
    <div
      class="table">
      <div class="tr">
        <span>How many pets need to have coverage?</span>
        <span>{{ getOptionName('petNumOptions', quoteForm.no_of_pet)  }}</span>
      </div>
      <div
        v-for="(item,index) in quoteForm.pet_info"
        :key="index">
        <div class="tr th">
          <span>{{'Pet'+(index+1)}}</span>
        </div>
        <div
          class="tr">
          <span>Species</span>
          <span>
            {{getAllOptionName31('type_of_pet',item.type_of_pet)}}
          </span>
        </div>
        <div
          class="tr">
          <span>Breed</span>
          <span>
            {{getAllOptionName31(item.type_of_pet==1?'cat_breeds':'dog_breeds',item.breed_id)}}
          </span>
        </div>
        <div
          class="tr">
          <span>Age</span>
          <span>{{getAllOptionName31('pet_ages',item.age)}}</span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import MixinOptions from '@/mixins/options'
export default {
  name: 'UnderwritingRefer',
  mixins: [MixinOptions],
  computed: {
    ...mapState('quote', ['quoteForm']),
    localAllOptions() {
      return this.allOptions31
    },
    nm_pa_list(){
      let {pet_info} = this.quoteForm||{}
      return pet_info||[]
    },
  }
}
</script>
